import {
  AlertCircleIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  AtIcon,
  BellIcon,
  BriefcaseSolidIcon,
  CalendarSolidIcon,
  CameraIcon,
  CheckSentIcon,
  CheckSingleIcon,
  ChevronDoubleLeft,
  ChevronDoubleRight,
  ChevronLeft,
  ChevronRight,
  CircleCheckSolidIcon,
  CloseCircleIcon,
  DocumentSolidIcon,
  EditPencilIcon,
  EmptyChatIcon,
  EmptyNotificationIcon,
  ExternalLinkIcon,
  HeartIcon,
  PhoneIcon,
  ShareIcon,
  StarOutlineIcon,
  ThunderLightningIcon,
  WarningFullOutlineIcon,
  WarningOutlineIcon,
  WarningSolidIcon,
} from '../../images/icons';

export const iconRegistry = {
  'arrow-left': ArrowLeftIcon,
  'arrow-right': ArrowRightIcon,
  check: CheckSingleIcon,
  'check-sent': CheckSentIcon,
  'chevron-double-left': ChevronDoubleLeft,
  'chevron-double-right': ChevronDoubleRight,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'circle-check-solid': CircleCheckSolidIcon,
  'empty-chat': EmptyChatIcon,
  'empty-notification': EmptyNotificationIcon,
  'external-link': ExternalLinkIcon,
  'star-outline': StarOutlineIcon,
  'thunder-lightning': ThunderLightningIcon,
  warning: WarningFullOutlineIcon,
  'warning-outline': WarningOutlineIcon,
  'warning-solid': WarningSolidIcon,
  at: AtIcon,
  bell: BellIcon,
  camera: CameraIcon,
  heart: HeartIcon,
  phone: PhoneIcon,
  share: ShareIcon,
  'close-circle': CloseCircleIcon,
  'briefcase-solid': BriefcaseSolidIcon,
  'calendar-solid': CalendarSolidIcon,
  'document-solid': DocumentSolidIcon,
  'alert-circle': AlertCircleIcon,
  'edit-pencil': EditPencilIcon,
};
